import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCurrentPage } from "../store/navSlice";
import ConsultationFormDialog from "./Consultation";
import CallEndIcon from "@mui/icons-material/CallEnd";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  Drawer,
  AppBar,
  Toolbar,
  ListItemText,
  Button,
  Grid,
  Card,
  CardContent,
  Stack,
  alpha,
  Avatar,
  Divider,
  Chip,
  IconButton,
  CircularProgress,
  Alert,
  CardMedia,
  Paper,
  useTheme,
  useMediaQuery,
  Fade,
  Fab,
} from "@mui/material";
import { styled, keyframes } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import LogoImage from "../images/decodia-logo.png";
// Import all Material Icons
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import StarIcon from "@mui/icons-material/Star";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import GroupsIcon from "@mui/icons-material/Groups";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import HistoryIcon from "@mui/icons-material/History";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PeopleIcon from "@mui/icons-material/People";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import PinterestIcon from "@mui/icons-material/Pinterest";
import FlagIcon from "@mui/icons-material/Flag";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteIcon from "@mui/icons-material/Favorite";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import HomeIcon from "@mui/icons-material/Home";
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";
// Add these additional icons
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ArchitectureIcon from "@mui/icons-material/Architecture";
import ColorLensIcon from "@mui/icons-material/ColorLens";
import BrushIcon from "@mui/icons-material/Brush";
import PaletteIcon from "@mui/icons-material/Palette";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import ChairIcon from "@mui/icons-material/Chair";
import BathtubIcon from "@mui/icons-material/Bathtub";
import KitchenIcon from "@mui/icons-material/Kitchen";
import BedIcon from "@mui/icons-material/Bed";
import LivingIcon from "@mui/icons-material/Living";
import BalconyIcon from "@mui/icons-material/Balcony";
import YardIcon from "@mui/icons-material/Yard";
import GarageIcon from "@mui/icons-material/Garage";
import CheckIcon from "@mui/icons-material/Check";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import YouTubeIcon from "@mui/icons-material/YouTube";
import LanguageIcon from "@mui/icons-material/Language";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import About_decodia from "../vedio/About_decodia.mp4";
import missionImage from "../images/misson_image.jpg";
import visionImage from "../images/vision-image.jpg";
import director1 from "../images/director1.png";
import ChatButton from "../components/freeChatComponent/ChatButton";

const iconComponents = {
  ArrowForwardIcon,
  ArrowBackIcon,
  StarIcon,
  DesignServicesIcon,
  GroupsIcon,
  VerifiedUserIcon,
  HistoryIcon,
  CheckCircleIcon,
  PeopleIcon,
  EmojiEventsIcon,
  LocationOnIcon,
  CalendarTodayIcon,
  ChatBubbleIcon,
  LinkedInIcon,
  TwitterIcon,
  InstagramIcon,
  FacebookIcon,
  PinterestIcon,
  FlagIcon,
  VisibilityIcon,
  FavoriteIcon,
  LightbulbIcon,
  HomeIcon,
  BusinessIcon,
  ApartmentIcon,
  PhoneIcon,
  EmailIcon,
  AccessTimeIcon,
  ArrowRightAltIcon,
  TrendingUpIcon,
  ArchitectureIcon,
  ColorLensIcon,
  BrushIcon,
  PaletteIcon,
  DashboardIcon,
  SpaceDashboardIcon,
  ChairIcon,
  BathtubIcon,
  KitchenIcon,
  BedIcon,
  LivingIcon,
  BalconyIcon,
  YardIcon,
  GarageIcon,
  CheckIcon,
  ExpandMoreIcon,
  PlayArrowIcon,
  PauseIcon,
  FiberManualRecordIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowUpwardIcon,
  ArrowDownwardIcon,
  NavigateBeforeIcon,
  NavigateNextIcon,
  MenuIcon,
  CloseIcon,
  SearchIcon,
  AccountCircleIcon,
  ShoppingCartIcon,
  YouTubeIcon,
  LanguageIcon,
  KeyboardArrowDownIcon,
  KeyboardArrowUpIcon,
};

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
`;

const HeroSection = styled(Box)(({ theme }) => ({
  position: "relative",
  color: "white",
  padding: theme.spacing(15, 0, 10),
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
}));

// Add a VideoBackground component
const VideoBackground = ({ videoSrc }) => {
  const videoRef = useRef(null);

  useEffect(() => {
    // Ensure video plays correctly
    if (videoRef.current) {
      videoRef.current.play().catch((e) => {
        // Fallback to muted autoplay
        videoRef.current.muted = true;
        videoRef.current.play();
      });
    }
  }, []);

  return (
    <>
      <Box
        component="video"
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          zIndex: -2,
        }}
      >
        <source src={videoSrc} type="video/mp4" />
      </Box>

      {/* Dark overlay for better text visibility */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: -1,
        }}
      />
    </>
  );
};

const SectionContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(10, 0),
  backgroundColor: "white",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
}));

const SocialIconButton = styled(IconButton)(({ color }) => ({
  backgroundColor: alpha(color || "#FF6B35", 0.1),
  "&:hover": {
    backgroundColor: alpha(color || "#FF6B35", 0.2),
  },
}));

// REUSABLE COMPONENTS

const MissionDetails = ({ details, color }) => (
  <Box sx={{ maxWidth: 600 }}>
    {details.map((detail, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          mb: 2,
          p: 2,
          borderRadius: "12px",
          backgroundColor: alpha(color, 0.05),
          borderLeft: `4px solid ${color}`,
          transition: "transform 0.2s ease",
          "&:hover": {
            transform: "translateX(4px)",
            backgroundColor: alpha(color, 0.08),
          },
        }}
      >
        <CheckCircleIcon
          sx={{
            color: color,
            fontSize: 20,
            mr: 2,
            mt: 0.5,
            flexShrink: 0,
          }}
        />
        <Typography
          variant="body1"
          sx={{
            color: "rgba(255, 255, 255, 0.95)",
            lineHeight: 1.6,
          }}
        >
          {detail}
        </Typography>
      </Box>
    ))}
  </Box>
);

const VisionGoals = ({ goals }) => (
  <Grid container spacing={3}>
    {goals.map((goal) => (
      <Grid item xs={12} sm={6} key={goal.id}>
        <Box
          sx={{
            p: 3,
            backgroundColor: alpha(goal.color, 0.1),
            borderRadius: "16px",
            border: `1px solid ${alpha(goal.color, 0.2)}`,
            height: "100%",
            transition: "all 0.3s ease",
            "&:hover": {
              transform: "translateY(-4px)",
              boxShadow: `0 10px 30px ${alpha(goal.color, 0.2)}`,
              backgroundColor: alpha(goal.color, 0.15),
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 2,
            }}
          >
            <Box
              sx={{
                p: 1.5,
                backgroundColor: alpha(goal.color, 0.15),
                borderRadius: "10px",
              }}
            >
              {/* Assuming renderIcon function exists */}
              {React.createElement(
                iconComponents[goal.icon] || CheckCircleIcon,
                {
                  sx: { fontSize: 24, color: goal.color },
                },
              )}
            </Box>
            <Typography
              variant="h6"
              fontWeight={600}
              sx={{ color: goal.color }}
            >
              {goal.title}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255, 255, 255, 0.9)",
              lineHeight: 1.6,
            }}
          >
            {goal.description}
          </Typography>
        </Box>
      </Grid>
    ))}
  </Grid>
);

const ImageCard = ({ imageSrc, imageAlt }) => (
  <Box
    sx={{
      position: "relative",
      borderRadius: "20px",
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.2)",
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "linear-gradient(45deg, rgba(255,123,66,0.1), transparent)",
        zIndex: 1,
        borderRadius: "20px",
      },
    }}
  >
    <Box
      component="img"
      src={imageSrc}
      alt={imageAlt}
      sx={{
        width: "100%",
        height: { xs: 300, sm: 400, md: 500 },
        objectFit: "cover",
        transition: "transform 0.5s ease",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    />
  </Box>
);

const MissionVisionCard = ({
  type,
  title,
  description,
  details,
  goals,
  icon,
  color,
  imageSrc,
  imageAlt,
  reverse = false,
  renderIcon,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: reverse ? "row-reverse" : "row" },
        alignItems: "center",
        gap: { xs: 4, md: 8 },
        bgcolor: "rgba(255, 255, 255, 0.05)",
        borderRadius: "24px",
        p: { xs: 4, md: 6 },
        boxShadow: "0 10px 40px rgba(0, 0, 0, 0.1)",
      }}
    >
      {/* Text Content */}
      <Box sx={{ width: { xs: "100%", md: "50%" } }}>
        <Box sx={{ mb: 4 }}>
          {/* Icon Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              mb: 3,
              justifyContent: { xs: "center", md: "flex-start" },
            }}
          >
            <Box
              sx={{
                p: 2,
                backgroundColor: alpha(color, 0.1),
                borderRadius: "12px",
              }}
            >
              {renderIcon(icon, {
                sx: {
                  fontSize: 32,
                  color: color,
                },
              })}
            </Box>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                color: "#fff",
                fontSize: { xs: "1.8rem", sm: "2.2rem", md: "2.5rem" },
                lineHeight: 1.2,
              }}
            >
              {title}
            </Typography>
          </Box>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              color: "rgba(255, 255, 255, 0.95)",
              mb: 4,
              lineHeight: 1.7,
              fontSize: { xs: "1rem", sm: "1.1rem" },
            }}
          >
            {description}
          </Typography>

          {type === "mission" ? (
            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{
                  mb: 3,
                  color: "#fff",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                What We Do:
              </Typography>
              <MissionDetails details={details} color={color} />
            </Box>
          ) : (
            <Box>
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{
                  mb: 4,
                  color: "#fff",
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Our Future Goals:
              </Typography>
              <VisionGoals goals={goals} />
            </Box>
          )}
        </Box>
      </Box>
      <Box sx={{ width: { xs: "100%", md: "50%" } }}>
        <ImageCard imageSrc={imageSrc} imageAlt={imageAlt} />
      </Box>
    </Box>
  );
};

const CoreValuesSection = () => {
  const coreValues = [
    {
      id: 1,
      title: "Innovation",
      description:
        "Continuously pushing boundaries and exploring new possibilities in design",
      icon: "LightbulbIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
    {
      id: 2,
      title: "Integrity",
      description:
        "Upholding the highest standards of honesty and ethical practices",
      icon: "VerifiedUserIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
    {
      id: 3,
      title: "Excellence",
      description:
        "Striving for superior quality in every project we undertake",
      icon: "StarIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
    {
      id: 4,
      title: "Collaboration",
      description: "Working together with clients to bring visions to life",
      icon: "GroupsIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
    {
      id: 5,
      title: "Creativity",
      description:
        "Transforming spaces with unique and innovative design solutions",
      icon: "PaletteIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
    {
      id: 6,
      title: "Client-Centric",
      description: "Putting our clients' needs and visions at the forefront",
      icon: "PeopleIcon",
      color: "#f7f5f4ff",
      backgroundColor: "#E55A2B",
      gradient: "linear-gradient(135deg, #E55A2B 0%, #FF8E53 100%)",
    },
  ];

  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        position: "relative",
        background: `
        linear-gradient(rgba(61, 61, 61, 0.6), rgba(61, 60, 60, 0.6)),
url('https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: { xs: "scroll", md: "fixed" },
      }}
    >
      <Container maxWidth="lg">
        {/* Section Header */}
        <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" },
              fontWeight: 800,
              mb: 2,
              color: "#f2efeeff",
              lineHeight: 1.1,
              position: "relative",
              display: "inline-block",
              "&:after": {
                content: '""',
                position: "absolute",
                bottom: -10,
                left: "50%",
                transform: "translateX(-50%)",
                width: { xs: 60, md: 80 },
                height: 4,
                backgroundColor: "#E55A2B",
                borderRadius: 2,
              },
            }}
          >
            Our Core Values
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#f2efeeff",
              mb: 4,
              maxWidth: 700,
              mx: "auto",
              fontSize: { xs: "0.95rem", sm: "1rem", md: "1.1rem" },
              lineHeight: 1.7,
              mt: 4,
              px: { xs: 2, md: 0 },
            }}
          >
            The guiding principles that shape our work, define our culture, and
            drive our commitment to delivering exceptional design experiences
          </Typography>
        </Box>

        {/* Core Values Grid */}
        <Grid container spacing={3}>
          {coreValues.map((value, index) => (
            <Grid item xs={12} sm={6} lg={4} key={value.id}>
              <Fade
                in={true}
                timeout={500}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <Box
                  sx={{
                    height: "100%",
                    p: { xs: 3, md: 4 },
                    width: { xs: "100%", sm: "100%", md: 300 },
                    backgroundColor: "white",
                    borderRadius: "16px",
                    border: "1px solid rgba(0, 0, 0, 0.05)",
                    boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    position: "relative",
                    overflow: "hidden",
                    mx: { xs: "auto", md: 0 },
                    "&:hover": {
                      transform: { xs: "none", md: "translateY(-8px)" },
                      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.15)",
                      "& .value-icon": {
                        transform: { xs: "none", md: "scale(1.1) rotate(5deg)" },
                      },
                      "& .value-number": {
                        opacity: 0.05,
                        transform: { xs: "none", md: "scale(1.5)" },
                      },
                    },
                    "&:before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: value.gradient,
                      borderRadius: "16px 16px 0 0",
                    },
                  }}
                >
                  {/* Background Number */}
                  <Typography
                    className="value-number"
                    sx={{
                      position: "absolute",
                      top: 10,
                      right: 20,
                      fontSize: { xs: "4rem", md: "6rem" },
                      fontWeight: 900,
                      color: alpha(value.color, 0.05),
                      lineHeight: 1,
                      transition: "all 0.3s ease",
                      userSelect: "none",
                    }}
                  >
                    {index + 1}
                  </Typography>

                  {/* Icon Container */}
                  <Box
                    className="value-icon"
                    sx={{
                      width: { xs: 60, md: 70 },
                      height: { xs: 60, md: 70 },
                      borderRadius: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 3,
                      background: value.gradient,
                      transition: "all 0.3s ease",
                      boxShadow: `0 10px 20px ${alpha(value.color, 0.2)}`,
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {React.createElement(
                      iconComponents[value.icon] || CheckCircleIcon,
                      {
                        sx: {
                          fontSize: { xs: 28, md: 32 },
                          color: "white",
                          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.2))",
                        },
                      },
                    )}
                  </Box>

                  {/* Title */}
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 800,
                      mb: 2,
                      color: "#1D3557",
                      fontSize: { xs: "1.2rem", md: "1.4rem" },
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {value.title}
                  </Typography>

                  {/* Description */}
                  <Typography
                    variant="body2"
                    sx={{
                      color: "#666",
                      lineHeight: 1.7,
                      fontSize: { xs: "0.85rem", md: "0.95rem" },
                      position: "relative",
                      zIndex: 2,
                    }}
                  >
                    {value.description}
                  </Typography>

                  {/* Hover Line */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 0,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 40,
                      height: 3,
                      backgroundColor: value.color,
                      borderRadius: 2,
                      opacity: 0,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        opacity: 1,
                        width: 100,
                      },
                    }}
                  />
                </Box>
              </Fade>
            </Grid>
          ))}
        </Grid>

        {/* Bottom Quote */}
        <Fade in={true} timeout={1000}>
          <Box
            sx={{
              mt: { xs: 6, md: 8 },
              p: { xs: 3, md: 4 },
              backgroundColor: alpha("#E55A2B", 0.8),
              borderRadius: "16px",
              border: `1px solid ${alpha("#E55A2B", 0.1)}`,
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: -50,
                left: -50,
                width: 100,
                height: 100,
                borderRadius: "50%",
                backgroundColor: alpha("#E55A2B", 0.1),
                filter: "blur(40px)",
              }}
            />
            <Box
              sx={{
                position: "absolute",
                bottom: -50,
                right: -50,
                width: 100,
                height: 100,
                borderRadius: "50%",
                backgroundColor: alpha("#1D3557", 0.1),
                filter: "blur(40px)",
              }}
            />

            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#faf3f1ff",
                mb: 2,
                position: "relative",
                zIndex: 2,
                fontSize: { xs: "1rem", md: "1.1rem" },
                px: { xs: 1, md: 0 },
              }}
            >
              "Our values are not just words on a wall—they are the principles
              that guide every decision, every design, and every interaction
              with our clients."
            </Typography>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 2,
                mt: 2,
                position: "relative",
                zIndex: 2,
                flexWrap: "wrap",
              }}
            >
              <Box sx={{ width: { xs: 30, md: 40 }, height: 1, backgroundColor: "#E55A2B" }} />
              <Typography
                variant="body2"
                sx={{
                  color: "#faf3f1ff",
                  fontWeight: 600,
                  fontSize: { xs: "0.8rem", md: "0.9rem" },
                }}
              >
                DECODIA TEAM.
              </Typography>
              <Box sx={{ width: { xs: 30, md: 40 }, height: 1, backgroundColor: "#E55A2B" }} />
            </Box>
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};
const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const slideDown = keyframes`
  from { 
    opacity: 0;
    transform: translateY(-10px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;

const underline = keyframes`
  from { width: 0; }
  to { width: 100%; }
`;

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const pulseAnimation = keyframes`
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.02); }
`;
const shimmerAnimation = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [openForm, setOpenForm] = useState(false);

  const { menuItems } = useSelector((state) => state.navigation);

  const [scrolled, setScrolled] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const currentPath = location.pathname;

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavigation = (path, label) => {
    navigate(path);
    dispatch(setCurrentPage(label));
    setDrawerOpen(false);
  };

  const desktopMenu = (
    <Box
      sx={{
        display: "flex",
        gap: 4,
        alignItems: "center",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      {menuItems.map((item, index) => (
        <Box
          key={item.id}
          sx={{
            animation: `${slideDown} 0.4s ease-out ${index * 0.05}s forwards`,
            opacity: 0,
          }}
        >
          <Button
            onClick={() => handleNavigation(item.path, item.label)}
            sx={{
              color: "white",
              textTransform: "none",
              fontWeight: 600,
              fontSize: "0.95rem",
              position: "relative",
              padding: "8px 12px",
              minWidth: "auto",
              borderRadius: "4px",
              transition: "all 0.3s ease",

              "&:hover": {
                color: "#EED688",
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.1), rgba(238, 214, 136, 0.1))",
                transform: "translateY(-2px)",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #EED688)",
                  animation: `${underline} 0.3s ease-out`,
                  borderRadius: "2px",
                },
              },

              ...(currentPath === item.path && {
                color: "#FF6B35",
                fontWeight: 700,
                background:
                  "linear-gradient(135deg, rgba(255, 107, 53, 0.15), rgba(255, 142, 83, 0.1))",

                "&::after": {
                  content: '""',
                  position: "absolute",
                  width: "100%",
                  height: "2px",
                  bottom: "0",
                  left: "0",
                  background:
                    "linear-gradient(90deg, #FF6B35, #FF8E53, #FF6B35)",
                  borderRadius: "2px",
                  animation: `${pulseAnimation} 2s infinite`,
                },
              }),
            }}
          >
            {item.label}
          </Button>
        </Box>
      ))}

      <Box
        sx={{
          animation: `${slideDown} 0.4s ease-out 0.3s forwards`,
          opacity: 0,
          ml: 1,
        }}
      >
        <Button
          variant="contained"
          onClick={() => setOpenForm(true)}
          sx={{
            background: "linear-gradient(45deg, #FF6B35 0%, #FF8E53 100%)",
            backgroundSize: "200% 200%",
            color: "white",
            fontWeight: 700,
            borderRadius: "8px",
            padding: "10px 24px",
            fontSize: "0.95rem",
            textTransform: "none",
            position: "relative",
            overflow: "hidden",
            animation: `${pulseAnimation} 3s infinite`,
            transition: "all 0.3s ease",

            "&:hover": {
              background: "linear-gradient(45deg, #E55A2B 0%, #FF7B42 100%)",
              transform: "translateY(-2px)",
              boxShadow: "0 8px 20px rgba(255, 107, 53, 0.3)",
              animation: `${pulseAnimation} 1.5s infinite`,

              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-100%",
                width: "100%",
                height: "100%",
                background:
                  "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)",
                animation: `${shimmerAnimation} 1.5s ease-out`,
              },
            },
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <ChatBubbleIcon sx={{ fontSize: 18 }} />
            Free Consultation
          </Box>
        </Button>

        <ConsultationFormDialog
          open={openForm}
          onClose={() => setOpenForm(false)}
        />
      </Box>
    </Box>
  );

  const mobileMenu = (
    <>
      <IconButton
        onClick={() => setDrawerOpen(true)}
        sx={{
          color: "white",
          animation: `${fadeIn} 0.5s ease-out`,
          transition: "transform 0.3s ease",

          "&:hover": {
            transform: "rotate(90deg)",
          },
        }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        sx={{
          "& .MuiDrawer-paper": {
            width: 280,
            background: "linear-gradient(135deg, #0F0F0F 0%, #1a1a1a 100%)",
            color: "white",
            animation: `${fadeIn} 0.3s ease-out`,
          },
        }}
      >
        <Box sx={{ p: 3 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 50, width: "auto" }}
            />
            <IconButton
              onClick={() => setDrawerOpen(false)}
              sx={{
                color: "white",
                transition: "transform 0.3s ease",

                "&:hover": {
                  transform: "rotate(90deg)",
                },
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <List>
            {menuItems.map((item, index) => (
              <ListItem
                key={item.id}
                button
                onClick={() => handleNavigation(item.path, item.label)}
                sx={{
                  py: 2,
                  mb: 1,
                  borderRadius: "4px",
                  backgroundColor:
                    currentPath === item.path
                      ? "rgba(255, 107, 53, 0.1)"
                      : "transparent",
                  animation: `${fadeIn} 0.3s ease-out ${index * 0.05}s forwards`,
                  opacity: 0,
                  transition: "all 0.3s ease",

                  "&:hover": {
                    backgroundColor: "rgba(255, 107, 53, 0.05)",
                    paddingLeft: "20px",
                  },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{
                    fontWeight: 600,
                    color: currentPath === item.path ? "#FF6B35" : "white",
                  }}
                />
              </ListItem>
            ))}
          </List>

          <Box sx={{ mt: 3, p: 2 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => setOpenForm(true)}
              sx={{
                background: "linear-gradient(45deg, #FF6B35 30%, #FF8E53 90%)",
                color: "white",
                fontWeight: 600,
                borderRadius: "8px",
                padding: "14px 24px",
                animation: `${pulseAnimation} 3s infinite`,
                transition: "all 0.3s ease",

                "&:hover": {
                  background:
                    "linear-gradient(45deg, #E55A2B 30%, #FF7B42 90%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 15px rgba(255, 107, 53, 0.3)",
                  animation: `${pulseAnimation} 1.5s infinite`,
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                <ChatBubbleIcon sx={{ fontSize: 18 }} />
                Free Consultation
              </Box>
            </Button>
          </Box>
        </Box>
      </Drawer>
      <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
    </>
  );

  return (
    <AppBar
      position="absolute"
      elevation={0}
      sx={{
        background: "transparent",
        backdropFilter: scrolled ? "blur(10px)" : "none",
        transition: "all 0.3s ease",
        borderBottom: scrolled ? "1px solid rgba(255,255,255,0.1)" : "none",
        animation: `${fadeIn} 0.6s ease-out`,
      }}
    >
      <Container maxWidth="1400px" sx={{ margin: 0, px: 0, py: 2 }}>
        <Toolbar
          sx={{
            minHeight: 70,
            justifyContent: "space-between",
            width: "100%",
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          <Box
            onClick={() => handleNavigation("/", "Home")}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              transition: "transform 0.3s ease",

              "&:hover": {
                transform: "scale(1.05)",
              },
            }}
          >
            <img
              src={LogoImage}
              alt="DECODIA"
              style={{ height: 60, width: "auto" }}
            />
          </Box>

          {!isMobile ? desktopMenu : mobileMenu}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

// MAIN COMPONENT

const About = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const [openForm, setOpenForm] = useState(false);
  // Get all data from Redux store
  const aboutData = useSelector((state) => state.about);
  const {
    hero,
    missionVision,
    statistics,
    founders,
    teamMembers,
    values,
    timeline,
    whyChooseUs,
    office,
    cta,
    loading,
    error,
  } = aboutData;

  useEffect(() => {
    dispatch(setCurrentPage("About"));
  }, [dispatch]);

  // Helper function to render icon
  const renderIcon = (iconName, props = {}) => {
    const IconComponent = iconComponents[iconName];
    return IconComponent ? <IconComponent {...props} /> : null;
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress sx={{ color: "#FF6B35" }} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container sx={{ py: 10 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <>
      {/* HERO SECTION */}
      <HeroSection>
        <VideoBackground videoSrc={About_decodia} />
        <Navigation />
        <Container maxWidth="lg">
          <Box sx={{ textAlign: "center", width: "100%" }}>
            <Stack spacing={4} sx={{ alignItems: "center" }}>
              <Typography
                variant="h1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "1.8rem", md: "2.5rem" }, // reduced size
                  lineHeight: 1.4,
                  textTransform: "uppercase",
                  letterSpacing: "1px",
                  mb: 0,
                }}
              >
                {hero?.title || "About Decodia"}
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 400,
                  opacity: 0.9,
                  maxWidth: 800,
                  mb: 4,
                  animation: `${fadeInUp} 1s ease-out 0.2s both`,
                }}
              >
                {hero?.subtitle || "Creating spaces that inspire"}
              </Typography>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ animation: `${fadeInUp} 1s ease-out 0.4s both` }}
              >
                {hero?.buttons?.map((button) => (
                  <Button
                    key={button.id}
                    variant={button.variant}
                    size="large"
                    onClick={() => navigate(button.navigateTo)}
                    startIcon={
                      button.variant === "outlined"
                        ? null
                        : renderIcon(button.icon)
                    }
                    endIcon={button.variant === "outlined" ? null : undefined}
                    sx={{
                      px: { xs: 3, md: 4 },
                      py: { xs: 1.2, md: 1.5 },
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontWeight: 600,
                      backgroundColor: "#E55A2B",
                      borderColor: undefined,
                      color:
                        button.variant === "outlined" ? "#FFFFFF" : "#FFFFFF",
                      "&:hover": {
                        backgroundColor:
                          button.variant === "contained"
                            ? "#E55A2B"
                            : "#E55A2B",
                      },
                    }}
                  >
                    {button.text}
                  </Button>
                ))}
              </Stack>
            </Stack>
          </Box>
        </Container>
      </HeroSection>

      <Box
        sx={{
          py: { xs: 8, md: 12 },
          backgroundColor: "#f0f7ff",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Container maxWidth="lg">
          {/* Section Header */}
          <Box sx={{ textAlign: "center", mb: { xs: 6, md: 8 } }}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 700,
                fontSize: { xs: "2rem", md: "2.8rem" },
                mb: 3,
                color: "#1D3557",
                lineHeight: 1.2,
              }}
            >
              Why Choose Decodia
            </Typography>

            <Typography
              variant="h5"
              sx={{
                fontWeight: 400,
                color: "#666",
                maxWidth: 800,
                mx: "auto",
                lineHeight: 1.6,
                mb: 4,
                fontSize: { xs: "1.1rem", md: "1.3rem" },
                px: { xs: 2, md: 0 },
              }}
            >
              We're here to guide you at every step of your design journey.
            </Typography>
          </Box>

          <Grid container spacing={3} sx={{ mb: { xs: 6, md: 8 } }}>
            {[
              {
                id: 1,
                title: "Discover Your Interior Style",
                description:
                  "Complete our interior style quiz to receive personalized design concepts that match your unique taste.",
                icon: "PsychologyIcon",
                color: "#d4724eff",
                iconColor: "#e0e0e0",
              },
              {
                id: 2,
                title: "Consult with Design Experts",
                description:
                  "Receive personalized guidance from certified interior designers for your space transformation.",
                icon: "GroupsIcon",
                color: "#d4724eff",
                iconColor: "#e0e0e0",
              },
              {
                id: 3,
                title: "Complete Design Solutions",
                description:
                  "Full-service interior design from concept to final installation.",
                icon: "DescriptionIcon",
                color: "#d4724eff",
                iconColor: "#e0e0e0",
              },
              {
                id: 4,
                title: "Efficient Design Implementation",
                description:
                  "Beautiful interior transformations completed on schedule with minimal disruption.",
                icon: "AccessTimeIcon",
                color: "#d4724eff",
                iconColor: "#e0e0e0",
              },
            ].map((feature) => (
              <Grid item xs={12} sm={6} md={3} key={feature.id}>
                <Box
                  sx={{
                    height: "100%",
                    minHeight: 240,
                    width: { xs: "100%", sm: "100%", md: 270 },
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#d4724eff",
                    borderRadius: "12px",
                    textAlign: "center",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                    border: "1px solid rgba(255, 255, 255, 0.2)",
                    transition: "all 0.2s ease",
                    mx: { xs: "auto", md: 0 },
                    "&:hover": {
                      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.12)",
                      transform: { xs: "none", md: "translateY(-2px)" },
                    },
                  }}
                >
                  {/* Icon Container - Fixed */}
                  <Box
                    sx={{
                      width: 64,
                      height: 64,
                      minHeight: 64,
                      borderRadius: "50%",
                      backgroundColor: alpha("#ffffff", 0.15),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mx: "auto",
                      mb: 3,
                      flexShrink: 0,
                    }}
                  >
                    {React.createElement(
                      iconComponents[feature.icon] || CheckCircleIcon,
                      {
                        sx: {
                          fontSize: 32,
                          color: "#ffffff",
                        },
                      },
                    )}
                  </Box>

                  {/* Title - Fixed */}
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      mb: 1.5,
                      color: "#ffffff",
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      lineHeight: 1.3,
                      flexShrink: 0,
                    }}
                  >
                    {feature.title}
                  </Typography>

                  <Box
                    sx={{ flexGrow: 1, display: "flex", alignItems: "center" }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "rgba(255, 255, 255, 0.9)",
                        lineHeight: 1.5,
                        fontSize: "0.9rem",
                        display: "-webkit-box",
                        WebkitLineClamp: 3,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        minHeight: "4.5rem",
                        maxHeight: "4.5rem",
                        mt: "auto",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
          <Box
            sx={{
              backgroundColor: alpha("#E2725B", 0.1),
              borderRadius: "12px",
              p: 3,
              mb: 6,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              alignItems: "center",
              justifyContent: "center",
              gap: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircleIcon sx={{ color: "#E2725B", fontSize: 20 }} />
              <Typography sx={{ color: "#1D3557", fontWeight: 500, fontSize: { xs: "0.9rem", md: "1rem" } }}>
                100% Online Consultation
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircleIcon sx={{ color: "#E2725B", fontSize: 20 }} />
              <Typography
                sx={{
                  color: "#1D3557",
                  fontWeight: 500,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                }}
              >
                Flexible Design Schedules
              </Typography>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <CheckCircleIcon sx={{ color: "#E2725B", fontSize: 20 }} />
              <Typography
                sx={{
                  color: "#1D3557",
                  fontWeight: 500,
                  fontSize: { xs: "0.9rem", md: "1rem" },
                }}
              >
                Certified Design Professionals
              </Typography>
            </Box>
          </Box>

          {/* CTA Section */}
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "20px",
              p: { xs: 4, md: 6 },
              boxShadow: "0 10px 40px rgba(0, 0, 0, 0.08)",
              textAlign: "center",
              border: "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                mb: 3,
                color: "#1D3557",
                fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
              }}
            >
              Get Personalized Design Recommendations
            </Typography>

            <Typography
              variant="body1"
              sx={{
                color: "#666",
                mb: 4,
                maxWidth: 600,
                mx: "auto",
                lineHeight: 1.7,
                fontSize: { xs: "1rem", md: "1.1rem" },
                px: { xs: 2, md: 0 },
              }}
            >
              Confused about the best design style for your space? Discover your
              perfect interior style with our personalized design recommendation
              tool.
            </Typography>

            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={3}
              justifyContent="center"
              alignItems="center"
            >
              <Button
                variant="contained"
                size="large"
                onClick={() => navigate("/contact")}
                sx={{
                  backgroundColor: "#E2725B",
                  color: "white",
                  px: { xs: 4, md: 5 },
                  py: { xs: 1.2, md: 1.5 },
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 600,
                  borderRadius: "50px",
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": {
                    backgroundColor: "#d1654f",
                    transform: { xs: "none", md: "translateY(-2px)" },
                    boxShadow: "0 10px 20px rgba(226, 114, 91, 0.3)",
                  },
                }}
              >
                Contact US
                <ArrowForwardIcon sx={{ ml: 1 }} />
              </Button>

              <Button
                variant="outlined"
                size="large"
                onClick={() => setOpenForm(true)}
                sx={{
                  borderColor: "#E2725B",
                  color: "#E2725B",
                  px: { xs: 4, md: 5 },
                  py: { xs: 1.2, md: 1.5 },
                  fontSize: { xs: "1rem", md: "1.1rem" },
                  fontWeight: 600,
                  borderRadius: "50px",
                  width: { xs: "100%", sm: "auto" },
                  "&:hover": {
                    backgroundColor: alpha("#E2725B", 0.1),
                    borderColor: "#d1654f",
                  },
                }}
              >
                Book Free Consultation
              </Button>
            </Stack>

            <Typography
              variant="body2"
              sx={{
                color: "#999",
                mt: 4,
                fontSize: { xs: "0.8rem", md: "0.9rem" },
              }}
            >
              By proceeding you agree to our Terms of Use and Privacy Policy
            </Typography>
          </Box>

          {/* Add keyframes for pulse animation */}
          <style>
            {`
        @keyframes pulse {
          0% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.7; }
          100% { transform: scale(1); opacity: 1; }
        }
      `}
          </style>
        </Container>
      </Box>
      <SectionContainer
        sx={{
          py: { xs: 8, md: 12 },
          position: "relative",
          color: "#ffffff",
          overflow: "hidden",
          background: `
      linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)),
      url(https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80)
    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
        />
        <Container maxWidth="lg" sx={{ position: "relative", zIndex: 1 }}>
          {/* Header */}
          <Box
            sx={{
              textAlign: "center",
              mb: { xs: 8, md: 10 },
              px: { xs: 2, sm: 0 },
            }}
          >
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "2rem", sm: "2.5rem", md: "3.5rem" },
                fontWeight: 800,
                mb: 3,
                color: "#fff",
                letterSpacing: "-0.5px",
                lineHeight: 1.1,
              }}
            >
              Our Mission & Vision
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: { xs: "0.95rem", sm: "1.1rem", md: "1.2rem" },
                maxWidth: 600,
                mx: "auto",
                px: { xs: 2, md: 0 },
              }}
            >
              Driving innovation and creating meaningful impact through our core
              values and forward-thinking approach
            </Typography>
          </Box>

          {/* Main Content - White background box */}
          <Box
            sx={{
              bgcolor: "transparent",
              borderRadius: "8px",
              overflow: "hidden",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
            }}
          >
            {/* Vision Section - Top */}
            <Box
              sx={{
                p: { xs: 3, md: 6 },
                borderBottom: "2px solid #e0e0e0",
              }}
            >
              {/* Vision Header */}
              <Box
                sx={{
                  mb: 4,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "0.8rem", md: "0.9rem" },
                    color: "#fdfbfaff",
                    backgroundColor: "#E55A2B",
                    m: 1,
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    width: { xs: 180, md: 220 },
                    borderRadius: "16px",
                    p: 1,
                  }}
                >
                  WHAT WE ASPIRE TO BE
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
                    color: "#fef9f7ff ",
                    textTransform: "uppercase",
                    lineHeight: 1.2,
                    borderLeft: "4px solid #E55A2B ",
                    pl: 3,
                  }}
                >
                  {missionVision?.vision?.title || "Our Vision"}
                </Typography>
              </Box>

              {/* Vision Content */}
              <Typography
                variant="body1"
                sx={{
                  fontSize: { xs: "0.95rem", md: "1.1rem" },
                  lineHeight: 1.8,
                  pl: 3,
                  textTransform: "uppercase",
                  lineHeight: 1.2,
                  borderLeft: "4px solid #E55A2B ",
                }}
              >
                <Box
                  component="span"
                  sx={{ fontWeight: 700, color: "#fbf8f8ff" }}
                >
                  {missionVision?.vision?.description || "To be the"}
                </Box>{" "}
                <Box
                  component="span"
                  sx={{ fontWeight: 700, color: "#E55A2B" }}
                >
                  "very best"
                </Box>{" "}
                {missionVision?.vision?.description2 || "design firm in the industry"}
              </Typography>
            </Box>

            {/* Mission Section - Bottom */}
            <Box
              sx={{
                p: { xs: 3, md: 6 },
                bgcolor: "transparent",
              }}
            >
              {/* Mission Header */}
              <Box
                sx={{
                  mb: 4,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "0.8rem", md: "0.9rem" },
                    color: "#f7f4f2ff",
                    backgroundColor: "#E55A2B",
                    width: { xs: 200, md: 250 },
                    p: 1,
                    m: 1,
                    borderRadius: "10px",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                  }}
                >
                  WHO WE ARE, WHAT WE DO
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.2rem" },
                    color: "#f1efefff",
                    textTransform: "uppercase",
                    lineHeight: 1.2,
                    borderLeft: "4px solid #FF7B42",
                    pl: 3,
                  }}
                >
                  {missionVision?.mission?.title || "Our Mission"}
                </Typography>
              </Box>

              <Stack spacing={4}>
                {/* Point 1 */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 3,
                    p: { xs: 2, md: 3 },
                    borderRadius: "8px",
                    bgcolor: "transparent",
                    borderLeft: "4px solid #FF7B42",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 30, md: 40 },
                      height: { xs: 30, md: 40 },
                      borderRadius: "8px",
                      bgcolor: "#FF7B42",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 800,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      1
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        color: "#f6f4f3ff",
                        mb: 1,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        lineHeight: 1.3,
                        textTransform: "uppercase",
                      }}
                    >
                      Our mission is to create thoughtfully designed interiors
                      that balance concept, functionality, and emotion.
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#fffbfbff",
                        lineHeight: 1.7,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      We aim to understand our clients deeply — their lifestyle,
                      needs, and aspirations — and translate that understanding
                      into spaces that feel intuitive, comfortable, and refined.
                      Through clear planning, honest communication, and careful
                      execution, we deliver designs that are personal,
                      purposeful, and built to last.
                    </Typography>
                  </Box>
                </Box>

                {/* Point 2 */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 3,
                    p: { xs: 2, md: 3 },
                    borderRadius: "8px",
                    bgcolor: "transparent",
                    borderLeft: "4px solid #FF7B42",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 30, md: 40 },
                      height: { xs: 30, md: 40 },
                      borderRadius: "8px",
                      bgcolor: "#FF7B42",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 800,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      2
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        color: "#fcf5f3ff",
                        mb: 1,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        lineHeight: 1.3,
                        textTransform: "uppercase",
                      }}
                    >
                      Our Design Ethos and Concept Before Style
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#f7efedff",
                        lineHeight: 1.7,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      The principles that guide every project we take on. Every
                      project begins with a strong concept. Styles may change,
                      but a well-defined idea gives the design clarity,
                      direction, and longevity.
                    </Typography>
                  </Box>
                </Box>

                {/* Point 3 */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 3,
                    p: { xs: 2, md: 3 },
                    borderRadius: "8px",
                    borderLeft: "4px solid #E55A2B",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 30, md: 40 },
                      height: { xs: 30, md: 40 },
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      backgroundColor: "#E55A2B",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 800,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      3
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        color: "#fbf7f7ff",
                        mb: 1,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        lineHeight: 1.3,
                      }}
                    >
                      People at the Centre AND Clarity Over Complexity
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#f9f0f0ff",
                        lineHeight: 1.7,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      We design for real lives, not idealised images. Comfort,
                      usability, and daily routines are considered just as
                      important as aesthetics. Good design should feel
                      effortless. We believe in clear layouts, thoughtful
                      material choices, and solutions that simplify living
                      rather than complicate it.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 3,
                    p: { xs: 2, md: 3 },
                    borderRadius: "8px",
                    borderLeft: "4px solid #E55A2B",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 30, md: 40 },
                      height: { xs: 30, md: 40 },
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      backgroundColor: "#E55A2B",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 800,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      4
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        color: "#fbf7f7ff",
                        mb: 1,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        lineHeight: 1.3,
                      }}
                    >
                      Honest Design Process
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#f9f0f0ff",
                        lineHeight: 1.7,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      Transparency matters. From planning to execution, we
                      maintain open communication so clients feel confident and
                      involved at every stage.
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 3,
                    p: { xs: 2, md: 3 },
                    borderRadius: "8px",
                    borderLeft: "4px solid #E55A2B",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                    flexDirection: { xs: "column", sm: "row" },
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 30, md: 40 },
                      height: { xs: 30, md: 40 },
                      borderRadius: "8px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                      backgroundColor: "#E55A2B",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "white",
                        fontWeight: 800,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                      }}
                    >
                      5
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 800,
                        color: "#fbf7f7ff",
                        mb: 1,
                        fontSize: { xs: "1rem", md: "1.2rem" },
                        lineHeight: 1.3,
                      }}
                    >
                      Timeless Over Trendy
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#f9f0f0ff",
                        lineHeight: 1.7,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      We don't chase what's popular today. Our focus is on
                      creating interiors that age gracefully and continue to
                      feel relevant over time.
                    </Typography>
                  </Box>
                </Box>
              </Stack>
            </Box>
          </Box>
        </Container>
      </SectionContainer>

      <CoreValuesSection />

      <Box
        sx={{
          py: { xs: 6, md: 15 },
          position: "relative",
          overflow: "hidden",
          background: `
      linear-gradient(rgba(29, 53, 87, 0.9), rgba(29, 53, 87, 0.95)),
      url('https://images.unsplash.com/photo-1519452639340-7f2c6122c8a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')
    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundAttachment: { xs: "scroll", md: "fixed" },
        }}
      >
        {/* Decorative elements - subtle overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
        radial-gradient(circle at 20% 80%, rgba(229, 90, 43, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 123, 66, 0.1) 0%, transparent 50%)
      `,
            zIndex: 0,
          }}
        />

        <Container
          maxWidth="lg"
          sx={{ position: "relative", zIndex: 1, px: { xs: 2, sm: 3, md: 4 } }}
        >
          {/* Header Section */}
          <Box sx={{ textAlign: "center", mb: { xs: 4, md: 10 } }}>
            <Typography
              variant="h1"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.2rem", md: "3.5rem" },
                fontWeight: 900,
                mb: 2,
                color: "#ffffff",
                lineHeight: 1.1,
                letterSpacing: "-0.5px",
                position: "relative",
                display: "inline-block",
                textShadow: "0 2px 10px rgba(0, 0, 0, 0.3)",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: { xs: 60, md: 100 },
                  height: { xs: 4, md: 6 },
                  background:
                    "linear-gradient(90deg, #E55A2B 0%, #FF8E53 100%)",
                  borderRadius: 3,
                },
              }}
            >
              Meet Our Visionaries
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: "rgba(255, 255, 255, 0.9)",
                mt: { xs: 4, md: 6 },
                maxWidth: 700,
                mx: "auto",
                px: { xs: 2, md: 0 },
                fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
                lineHeight: { xs: 1.6, md: 1.8 },
                fontWeight: 400,
                textShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
              }}
            >
              The brilliant minds behind Decodia who combine design expertise
              with business acumen to transform spaces and inspire innovation.
            </Typography>
          </Box>

          {/* Founder Profiles */}
          {founders?.map((founder) => (
            <Fade in={true} timeout={800} key={founder?.id || Math.random()}>
              <Box
                sx={{
                  mb: { xs: 4, md: 8 },
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "stretch", md: "center" },
                  gap: { xs: 3, md: 6 },
                  p: { xs: 2, sm: 3, md: 6 },
                  background: "rgba(255, 255, 255, 0.95)",
                  borderRadius: { xs: "16px", md: "24px" },
                  boxShadow: "0 15px 50px rgba(0, 0, 0, 0.12)",
                  transition: "all 0.3s ease",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                  "&:hover": {
                    transform: { xs: "none", md: "translateY(-8px)" },
                    boxShadow: {
                      xs: "0 15px 50px rgba(0, 0, 0, 0.12)",
                      md: `
              0 25px 60px rgba(0, 0, 0, 0.18),
              0 0 0 1px ${alpha(founder?.color || "#E55A2B", 0.2)}
            `,
                    },
                  },
                }}
              >
                {/* Left Founder Card */}
                <Box
                  sx={{
                    flex: { md: "0 0 300px" },
                    width: "100%",
                    maxWidth: { xs: "100%", md: "300px" },
                    mx: { xs: "auto", md: 0 },
                    minHeight: { xs: 320, md: 420 },
                    borderRadius: "24px",
                    position: "relative",
                    background: `linear-gradient(
            180deg,
            ${alpha(founder?.color || "#E55A2B", 0.06)} 0%,
            ${alpha(founder?.color || "#E55A2B", 0.02)} 100%
          )`,
                    border: `1px solid ${alpha(
                      founder?.color || "#E55A2B",
                      0.1
                    )}`,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 4,
                  }}
                >
                  {/* Initial Avatar */}
                  <Box
                    sx={{
                      width: { xs: 120, md: 150 },
                      height: { xs: 120, md: 150 },
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: `linear-gradient(
              135deg,
              ${founder?.color || "#FF6B35"} 0%,
              ${alpha(founder?.color || "#FF6B35", 0.85)} 100%
            )`,
                      boxShadow: `0 15px 35px ${alpha(
                        founder?.color || "#FF6B35",
                        0.35
                      )}`,
                      border: `6px solid ${alpha(
                        founder?.color || "#FF6B35",
                        0.15
                      )}`,
                      mb: 4,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "scale(1.06)",
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: { xs: "3rem", md: "4.5rem" },
                        fontWeight: 900,
                        color: "#fff",
                        textTransform: "uppercase",
                        lineHeight: 1,
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {founder?.name?.charAt(0) || "F"}
                    </Typography>
                  </Box>

                  {/* Founder Name */}
                  <Typography
                    sx={{
                      fontWeight: 800,
                      textAlign: "center",
                      color: "#1D3557",
                      fontSize: { xs: "1.4rem", md: "1.7rem" },
                      mb: 2,
                      lineHeight: 1.3,
                    }}
                  >
                    {founder?.name || "Team Member"}
                  </Typography>

                  {/* Role */}
                  <Chip
                    label={founder?.role}
                    sx={{
                      maxWidth: "100%",
                      px: 2,
                      py: 0.7,
                      height: "auto",
                      fontSize: "0.75rem",
                      fontWeight: 700,
                      letterSpacing: "0.5px",
                      background: founder?.color || "#E55A2B",
                      color: "#fff",
                      borderRadius: "30px",
                      textTransform: "uppercase",
                      boxShadow: `0 6px 20px ${alpha(
                        founder?.color || "#E55A2B",
                        0.25
                      )}`,
                      "& .MuiChip-label": {
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        px: 1,
                      },
                    }}
                  />

                  {/* Bottom Decorative Line */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 16,
                      left: "50%",
                      transform: "translateX(-50%)",
                      width: 60,
                      height: 4,
                      borderRadius: 10,
                      background: alpha(founder?.color || "#E55A2B", 0.3),
                    }}
                  />
                </Box>

                {/* Founder Details */}
                <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
                  {/* Bio */}
                  <Box sx={{ mb: { xs: 3, md: 4 } }}>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#444",
                        lineHeight: 1.9,
                        fontSize: { xs: "0.95rem", md: "1.05rem" },
                        fontFamily: "'Inter', sans-serif",
                      }}
                    >
                      {founder?.bio ||
                        "Experienced professional dedicated to excellence in design and client satisfaction."}
                    </Typography>
                  </Box>

                  {/* Experience */}
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mb: { xs: 3, md: 4 },
                      p: { xs: 2, md: 3 },
                      background: alpha(founder?.color || "#E55A2B", 0.05),
                      borderRadius: "18px",
                      border: `1px solid ${alpha(
                        founder?.color || "#E55A2B",
                        0.1
                      )}`,
                    }}
                  >
                    <Box sx={{ textAlign: "center" }}>
                      <Typography
                        variant="h3"
                        sx={{
                          fontWeight: 900,
                          color: founder?.color || "#E55A2B",
                          fontSize: { xs: "2rem", md: "2.8rem" },
                        }}
                      >
                        {founder?.experienceYears || "15+"}
                      </Typography>

                      <Typography
                        variant="body2"
                        sx={{
                          color: "#666",
                          fontWeight: 600,
                          letterSpacing: "1px",
                          textTransform: "uppercase",
                          fontSize: "0.75rem",
                        }}
                      >
                        Years Experience
                      </Typography>
                    </Box>
                  </Box>

                  {/* Fun Fact */}
                  <Box
                    sx={{
                      p: { xs: 2, md: 3 },
                      background: `linear-gradient(
              135deg,
              ${alpha(founder?.color || "#E55A2B", 0.08)} 0%,
              ${alpha(founder?.color || "#E55A2B", 0.03)} 100%
            )`,
                      borderRadius: "18px",
                      border: `1px solid ${alpha(
                        founder?.color || "#E55A2B",
                        0.1
                      )}`,
                      position: "relative",
                      overflow: "hidden",
                      mb: { xs: 2, md: 3 },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: 2,
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography sx={{ fontSize: "1.5rem" }}>💡</Typography>

                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: founder?.color || "#E55A2B",
                            mb: 0.5,
                            fontSize: "0.85rem",
                            letterSpacing: "1px",
                            textTransform: "uppercase",
                          }}
                        >
                          Fun Fact
                        </Typography>

                        <Typography
                          sx={{
                            color: "#555",
                            lineHeight: 1.7,
                            fontSize: { xs: "0.9rem", md: "0.95rem" },
                          }}
                        >
                          {founder?.funFact ||
                            "Passionate about creating beautiful spaces"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Social */}
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      mt: 3,
                      flexWrap: "wrap",
                    }}
                  >
                    {founder?.social?.linkedin && (
                      <IconButton
                        onClick={() =>
                          window.open(founder.social.linkedin, "_blank")
                        }
                        sx={{
                          background: `linear-gradient(
                  135deg,
                  ${founder?.color || "#E55A2B"} 0%,
                  ${alpha(founder?.color || "#E55A2B", 0.8)} 100%
                )`,
                          color: "#fff",
                          width: 44,
                          height: 44,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.1)",
                          },
                        }}
                      >
                        <LinkedInIcon fontSize="small" />
                      </IconButton>
                    )}

                    <Typography
                      sx={{
                        fontSize: "0.9rem",
                        color: "#666",
                        fontWeight: 500,
                      }}
                    >
                      Connect with {founder?.name?.split(" ")[0] || "them"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Fade>
          ))}
          {/* Team Philosophy */}
          <Fade in={true} timeout={1200}>
            <Box
              sx={{
                mt: { xs: 6, md: 12 },
                p: { xs: 3, sm: 4, md: 6 },
                background: `
            linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)
          `,
                borderRadius: { xs: "16px", md: "24px" },
                position: "relative",
                overflow: "hidden",
                backdropFilter: "blur(20px)",
                border: "1px solid rgba(255, 255, 255, 0.15)",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.3)",
              }}
            >
              {/* Background Pattern - adjusted for mobile */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  right: 0,
                  width: { xs: 150, md: 300 },
                  height: { xs: 150, md: 300 },
                  background: `radial-gradient(circle, ${alpha("#E55A2B", 0.15)} 0%, transparent 70%)`,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  bottom: 0,
                  left: 0,
                  width: { xs: 100, md: 200 },
                  height: { xs: 100, md: 200 },
                  background: `radial-gradient(circle, ${alpha("#1D3557", 0.15)} 0%, transparent 70%)`,
                }}
              />

              <Box
                sx={{ position: "relative", zIndex: 2, textAlign: "center" }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 800,
                    color: "#ffffff",
                    mb: { xs: 2, md: 3 },
                    fontSize: { xs: "1.3rem", sm: "1.5rem", md: "2.2rem" },
                    textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                    px: { xs: 1, md: 0 },
                  }}
                >
                  Our Collective Vision
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    color: "rgba(255, 255, 255, 0.9)",
                    maxWidth: 800,
                    mx: "auto",
                    px: { xs: 2, md: 0 },
                    fontSize: { xs: "0.9rem", sm: "1rem", md: "1.1rem" },
                    lineHeight: { xs: 1.6, md: 1.8 },
                    textShadow: "0 1px 3px rgba(0, 0, 0, 0.3)",
                    wordBreak: "break-word",
                  }}
                >
                  Together, we believe that great design should be accessible,
                  innovative, and transformative. Our leadership team combines
                  decades of experience with fresh perspectives to create spaces
                  that inspire, comfort, and elevate everyday life.
                </Typography>
              </Box>
            </Box>
          </Fade>
        </Container>
      </Box>

      <Box className="cta-section">
        <Container maxWidth="lg">
          <Box className="cta-content">
            <Box className="cta-icon">
              <CallEndIcon
                sx={{
                  fontSize: { xs: 40, sm: 50, md: 60 },
                  color: "#FF6B35",
                }}
              />
            </Box>
            <Typography
              className="cta-title"
              variant="h2"
              sx={{
                fontSize: { xs: "1.8rem", sm: "2.5rem", md: "3rem" },
                px: 2,
              }}
            >
              {cta?.title || "Ready to Transform Your Space?"}
            </Typography>
            <Typography
              className="cta-subtitle"
              variant="h6"
              sx={{
                opacity: 0.9,
                mb: { xs: 3, sm: 4 },
                fontSize: { xs: "1rem", sm: "1.25rem" },
                px: 2,
              }}
            >
              {cta?.subtitle || "Let's bring your vision to life"}
            </Typography>
            <Stack className="cta-buttons">
              <Button
                variant="contained"
                size="small"
                onClick={() => setOpenForm(true)}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  px: { xs: 2, sm: 2.5, md: 3 },
                  py: { xs: 0.75, sm: 0.75 },
                  fontSize: { xs: "0.875rem", sm: "0.9375rem" },
                }}
              >
                Book Free Consultation
              </Button>
              <Button
                variant="outlined"
                size="large"
                onClick={() => (window.location.href = `tel:${cta?.phone || "+1234567890"}`)}
                className="cta-button-secondary"
                sx={{
                  px: { xs: 3, sm: 4, md: 5 },
                  py: { xs: 1.25, sm: 1.5 },
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                }}
              >
                Call Now: {cta?.phone || "+1234567890"}
              </Button>
            </Stack>
            <Stack className="cta-features">
              {cta?.features?.map((feature, index) => (
                <Box key={index} className="cta-feature">
                  <CheckCircleIcon
                    sx={{
                      fontSize: { xs: 16, sm: 20 },
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontSize: { xs: "0.875rem", sm: "0.9rem" } }}
                  >
                    {feature}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </Box>
        </Container>
      </Box>
      <ConsultationFormDialog
        open={openForm}
        onClose={() => setOpenForm(false)}
      />
      <ChatButton />
    </>
  );
};

export default About;